import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

type Props = {
  isActive?: boolean
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownItem',
  props: {
    isActive: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(["dropdown-item", { 'is-active': _ctx.isActive, 'disabled-link': _ctx.disabled }]),
    role: "dropdown-item"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2 /* CLASS */))
}
}

})